import { ReactElement } from 'react';

import { CallsData, getStampByStatus } from '@philips-emr/hpms-provider-commons';
import FilterService from '@philips-emr/hpms-provider-commons/lib/services/filter-service';
import Controller, { OnClick, OnDynamicContentRender, OnMount, OnSelectItem, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import { Value } from '@philips-emr/tws-core/lib/types';

import { CallsAliases as Aliases, FragmentNames } from '../../codegen';
import { Route } from '../../route';
import BaseController from '../BaseController';

interface Call {
  array: any;
  nrSeqCall: number;
  dsStatus: string;
  dsJustificationCloseCall: string;
  dtOpenning: Date;
}

interface CallCategory {
  nrSeqCategory: number,
  dsCategory: string,
}

@Controller({ fragment: FragmentNames.CALLS })
class CallsController extends BaseController {

  @OnDynamicContentRender(Aliases.HPMS_CUSTOM_CARD_CALLS)
  onDynamicContentRenderCardCall(event: RenderEvent): void {
    const { data, render } = event;
    const { cdStatus, dsStatus } = data as CallsData;
    const content = (): ReactElement => (getStampByStatus(cdStatus, dsStatus));
    render(content);
  }

  @OnMount(Aliases.FILTER_CALLS)
  onFilterMount(event: MountEvent): void {
    FilterService.restoreFilterState(event);
  }

  @OnUnmount(Aliases.FILTER_CALLS)
  onUnmountFilter(event: MountEvent): void {
    FilterService.persistFilterState(event);
  }

  @OnClick(Aliases.ACTION_NEW_CALL)
  onClickNewCall(): void {
    this.historyService.push(Route.CALL_CATEGORY);
  }

  @OnSelectItem(Aliases.DECK_CALLS)
  onSelectInconsistency(event: SelectItemEvent<Record<string, Value>>): void {
    const data = event.item as unknown as Call;
    const { nrSeqCall } = data;
    this.historyService.push(Route.CALL_DETAIL, { nrSeqCall });
  }

}

export {
  Call,
  CallsController,
  CallCategory,
};
